import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import LayersOutlined from '@material-ui/icons/LayersOutlined';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import WmsMapSelect from './WmsMapSelect';
import useWMSLayers from "../useWMSLayers";
import useMapDisplayLayers from "./useMapDisplayLayers";
var AccordionPanels;
(function (AccordionPanels) {
    AccordionPanels["wms"] = "wms";
    AccordionPanels["vector"] = "vector";
})(AccordionPanels || (AccordionPanels = {}));
const useButtonStyles = makeStyles((theme) => createStyles({
    root: {
        backgroundColor: 'white',
        borderRadius: 24,
        fontSize: '14px',
    },
    buttonLayers: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        borderRadius: theme.spacing(3),
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    menu: {
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    checkButtons: {
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    accordion: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
}));
const RasterAndVectorLayersControl = (props) => {
    var _a, _b;
    const { map, baseLayerChangedNum, mwsLayerNum, changeLayers, changeVector, mwsLayers, mwsLayersTitle, vectorLayersTitle, vectorLayers, classes } = props;
    const styles = useButtonStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [expanded, setExpanded] = React.useState(AccordionPanels.wms);
    const handleChangeAccordion = (panel) => (_event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const [mwsLayer, setMwsLayers] = React.useState(0);
    useWMSLayers(map, baseLayerChangedNum !== null && baseLayerChangedNum !== void 0 ? baseLayerChangedNum : 1, mwsLayers[mwsLayer]);
    const [vectorLayersStatus, setVectorLayersStatus] = React.useState(vectorLayers.map(v => v.checked));
    const vectorLayersCurrent = React.useRef(vectorLayers);
    // if map not exist, add component after map appear
    React.useEffect(() => {
        if (!map)
            return;
        map.on('load', () => {
            vectorLayers.forEach((layer) => toggleLayers(layer, layer.checked));
            setVectorLayersStatus(vectorLayers.map(v => v.checked));
            setMwsLayers(mwsLayerNum !== null && mwsLayerNum !== void 0 ? mwsLayerNum : 0);
        });
    }, [map]);
    // if map exist, add component and set vector layers
    React.useEffect(() => {
        if (!map)
            return;
        vectorLayers.forEach((layer) => toggleLayers(layer, layer.checked));
        setVectorLayersStatus(vectorLayers.map(v => v.checked));
        setMwsLayers(mwsLayerNum !== null && mwsLayerNum !== void 0 ? mwsLayerNum : 0);
    }, []);
    const [exclusionLayersHide, setExclusionLayersHide] = React.useState(false);
    React.useEffect(() => {
        setExclusionLayersHide(mwsLayer === 1);
    }, [mwsLayer]);
    // Clear vector layers if they not in array
    React.useEffect(() => {
        // draw new vector layers
        vectorLayers.forEach((layer) => toggleLayers(layer, layer.checked, true));
        setVectorLayersStatus(vectorLayers.map(v => v.checked));
        setMwsLayers(mwsLayerNum !== null && mwsLayerNum !== void 0 ? mwsLayerNum : 0);
        return () => {
            // clear old vector layer which not exist in new layers
            vectorLayers.forEach((layer) => {
                if (!vectorLayersCurrent.current.includes(layer))
                    toggleLayers(layer, false, true);
            });
            vectorLayersCurrent.current = vectorLayers;
        };
    }, [vectorLayers]);
    const handleChangeCheckbox = (event) => {
        setVectorLayersStatus([]);
        vectorLayersStatus.map((elem, index) => {
            if (event.target.tabIndex === index)
                setVectorLayersStatus(prevArray => [...prevArray, !elem]);
            else
                setVectorLayersStatus(prevArray => [...prevArray, elem]);
        });
        const nameLayer = event.target.name;
        const stateCheckbox = event.target.checked;
        vectorLayers.map((layer) => {
            if (layer.name === nameLayer) {
                toggleLayers(layer, stateCheckbox, true);
                layer.checked = stateCheckbox;
            }
        });
        if (changeVector)
            changeVector(vectorLayers);
    };
    // isChecked - set or delete layers - fire when click to checkbox
    // change - it was toggle fire in checkbox click or init draw (no need delete layers)
    const toggleLayers = (vectorLayer, isChecked, change = false) => {
        if (!map || (!isChecked && !change))
            return;
        fetch(vectorLayer.tileURL).then(r => r.json()).then((style) => {
            if (style.layers && style.sources) {
                if (isChecked) {
                    // add source like layer name
                    for (const source in style.sources) {
                        if (!map.getSource(vectorLayer.name))
                            map.addSource(vectorLayer.name, style.sources[source]);
                    }
                    for (const layer of style.layers) {
                        const layerId = `vector_${layer.id}`;
                        if (!map.getLayer(layerId)) {
                            // ignore from mapbox types, there is a Custom that has no source properties
                            // @ts-ignore
                            map.addLayer(Object.assign(Object.assign({}, layer), { id: `vector_${layer.id}`, source: vectorLayer.name }));
                        }
                    }
                }
                else if (change) {
                    for (const layer of style.layers) {
                        const layerId = `vector_${layer.id}`;
                        if (map.getLayer(layerId))
                            map.removeLayer(layerId);
                    }
                    if (map.getSource(vectorLayer.name))
                        map.removeSource(vectorLayer.name);
                }
            }
        });
    };
    useMapDisplayLayers(exclusionLayersHide, map);
    const onClickButton = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleLayerChange = (newLayer) => {
        setMwsLayers(newLayer);
        if (changeLayers)
            changeLayers(newLayer);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: (_a = classes === null || classes === void 0 ? void 0 : classes.container) !== null && _a !== void 0 ? _a : styles.buttonLayers },
            React.createElement(Tooltip, { title: 'Layers', placement: 'right' },
                React.createElement(Paper, { className: (_b = classes === null || classes === void 0 ? void 0 : classes.button) !== null && _b !== void 0 ? _b : styles.root, elevation: (classes === null || classes === void 0 ? void 0 : classes.button) !== '' ? 3 : undefined },
                    React.createElement(IconButton, { onClick: onClickButton },
                        React.createElement(LayersOutlined, null)))),
            React.createElement(Menu, { anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), className: styles.menu, MenuListProps: { disablePadding: true } },
                React.createElement(Accordion, { className: styles.accordion, square: true, expanded: expanded === AccordionPanels.wms, onChange: handleChangeAccordion(AccordionPanels.wms) },
                    React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) },
                        React.createElement("span", null, mwsLayersTitle)),
                    React.createElement(WmsMapSelect, { selectedLayer: mwsLayer, mapLayers: mwsLayers, onLayerChange: newLayer => handleLayerChange(newLayer) })),
                React.createElement(Accordion, { className: styles.accordion, square: true, expanded: expanded === AccordionPanels.vector, onChange: handleChangeAccordion(AccordionPanels.vector) },
                    React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) },
                        React.createElement("span", null, vectorLayersTitle)),
                    React.createElement(FormGroup, { className: styles.checkButtons }, vectorLayers.map((layer, index) => (React.createElement(FormControlLabel, { key: index, control: (React.createElement(Checkbox, { checked: vectorLayersStatus[index], onChange: handleChangeCheckbox, name: layer.name, tabIndex: index })), label: layer.label })))))))));
};
export default RasterAndVectorLayersControl;
